import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Filters} from '../../common/filters';
import {fetchListings} from '../../../actions/listings';
import {pushEdapEvent, getRefinements} from '../../../utils/edap';
import {memoSelector} from '../../../utils/memo-selector';
import {UNREFINED_KEY} from '../../../utils/listings';

const MIN_SEGMENTS = 1;

const UNREFINED_SEGMENT = {
    name: 'Popular',
    messageKey: UNREFINED_KEY,
};

function transformSegments(segments = []) {
    return segments.length > MIN_SEGMENTS
        ? [UNREFINED_SEGMENT, ...segments]
        : null;
}

export function sendToEdap(refinementKey, position) {
    const mainData = {
        actionlocation: 'properties-module',
        eventrefinements: getRefinements({
            refinementKey,
            position,
            forceAddRefinementKey: true,
        }),
    };
    pushEdapEvent('refinement.click', mainData);
}

const getSegments = (state) => state.destination.segments;
const getSegmentFilters = (state) => state.modules.segmentFilters;

const selectSegments = memoSelector([getSegments], transformSegments);

export const mapStateToProps = (state) => ({
    segments: selectSegments(state),
    segmentFilters: getSegmentFilters(state),
});

function getButtonClasses(isActive) {
    return `btn btn-sm ${isActive ? 'btn-primary' : 'btn-default'}`;
}

export class SegmentFiltersComponent extends Component {
    static getDerivedStateFromProps(props, state) {
        const {overrideActive, filterOverride} = props;

        const {activeFilter} = state;

        if (overrideActive && filterOverride !== activeFilter) {
            return {
                activeFilter: filterOverride,
            };
        }

        return null;
    }

    constructor(props) {
        super(props);

        this.clickHandler = this.clickHandler.bind(this);

        this.state = {
            activeFilter: UNREFINED_KEY,
        };
    }

    clickHandler(segmentKey, position) {
        if (this.state.activeFilter === segmentKey) {
            return;
        }

        const {dispatch} = this.props;

        dispatch(fetchListings({segmentKey}));

        this.setState({
            activeFilter: segmentKey,
        });

        sendToEdap(segmentKey, position);
    }

    render() {
        const {activeFilter} = this.state;

        const {segments, segmentFilters} = this.props;

        if (!segments) {
            return null;
        }

        return (
            <Filters>
                {segments.map((segment, index) => (
                    <button
                        key={segment.messageKey}
                        className={getButtonClasses(
                            activeFilter === segment.messageKey
                        )}
                        onClick={this.clickHandler.bind(
                            null,
                            segment.messageKey,
                            index + 1
                        )} //eslint-disable-line
                    >
                        {segmentFilters[`${segment.messageKey}`]}
                    </button>
                ))}
            </Filters>
        );
    }
}

export const SegmentFilters = connect(mapStateToProps)(SegmentFiltersComponent);

SegmentFilters.displayName = 'SegmentFilters';

export default SegmentFilters;
